export default __webpack_public_path__ + "static/media/SB.8f0d7fac.svg";